import type { CmsImageWithFocalPoint } from '@omnia/ui'
import type { FC } from 'react'
import { useRef } from 'react'
import { HeaderImageInformationalModal } from '@/common/modal/headerImageInformational/HeaderImageInformationalModal'

interface OffersAndCompetitionsSummaryModalProps {
    show: boolean
    headerImage?: CmsImageWithFocalPoint
    modalTitle?: string
    modalContent: string
    closeButtonLabel: string
    onClose: () => void
    onButtonClick: () => void
}

export const OffersAndCompetitionsSummaryModal: FC<OffersAndCompetitionsSummaryModalProps> = ({
    show,
    headerImage,
    modalTitle,
    modalContent,
    closeButtonLabel,
    onClose,
    onButtonClick,
}) => {
    const shouldNavigateRef = useRef(false)

    const handleClose = () => {
        if (shouldNavigateRef.current) {
            onButtonClick()
        } else {
            onClose()
        }
        shouldNavigateRef.current = false
    }

    const handleClickCapture = (e: React.MouseEvent) => {
        const target = e.target as HTMLElement
        if (target.closest('.v-modal-footer__content button')) {
            shouldNavigateRef.current = true
        }
    }

    return (
        <div onClickCapture={handleClickCapture}>
            <HeaderImageInformationalModal
                show={show}
                headerImage={headerImage}
                modalTitle={modalTitle}
                modalContent={modalContent}
                closeButtonLabel={closeButtonLabel}
                onClose={handleClose}
            />
        </div>
    )
}